module.exports = require("axios");


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 16
// module chunks = 0